import { render } from "./HoverTooltip.vue?vue&type=template&id=670f5fc0&ts=true"
import script from "./HoverTooltip.vue?vue&type=script&lang=ts"
export * from "./HoverTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__